import { type FC } from 'react'

import { GrowthTrackEvent, useTracking } from '../../../apps/professional-app/fa/common/tracking'
import { BannerSlot } from '../../../components/BannerStack/BannerStack'
import { BANNER_PRIORITY } from '../bannerPriority'
import { McpPromoBanner } from './McpPromoBanner'
import { MCP_PROMO_SOURCE, McpPromoPage } from './mcpPromoConfig'
import { useMcpPromoBanner } from './useMcpPromoBanner'

interface McpPromoBannersProps {
  page: McpPromoPage
}

export const McpPromoBanners: FC<McpPromoBannersProps> = ({ page }) => {
  const { variant, block, shouldShow, isFetching, dismiss, probes } = useMcpPromoBanner(page)
  const { trackingClient } = useTracking()

  const handleCtaClick = () => {
    if (variant === 'admin') {
      trackingClient.track({ eventName: GrowthTrackEvent.MCP_ADMIN_PROMO_CLICKED })
      return
    }
    if (variant === null || page === McpPromoPage.INTEGRATION_SETTINGS) {
      return
    }
    trackingClient.track({
      eventName: GrowthTrackEvent.MCP_USER_PROMO_CLICKED,
      eventDetails: { type: variant, source: MCP_PROMO_SOURCE[page] },
    })
  }

  return (
    <>
      {probes}
      <BannerSlot id='mcpPromo' priority={BANNER_PRIORITY.MCP_PROMO} isFetching={isFetching} shouldShow={shouldShow}>
        {block !== null ? <McpPromoBanner block={block} onCtaClick={handleCtaClick} onDismiss={dismiss} /> : null}
      </BannerSlot>
    </>
  )
}
